import { compact, differenceWith, isEqual, isEmpty } from "lodash-es";
import {
  ACHIEVEMENTS,
  ACHIEVEMENTS_BG_COLORS,
  ACHIEVEMENTS_ORDER,
} from "../constants/achievement.config";
import { Achievement } from "@onmo/graphql/graphql";

export const convertAchievement = (achievement: Achievement) => {
  const achievementAssets = ACHIEVEMENTS.find((a) => a.id === achievement.id);

  return {
    id: achievement.id,
    currentTier: achievement.currentTier,
    progress: Math.round(
      achievement.id === "time_played"
        ? achievement.progress / 60
        : achievement.progress,
    ),
    progressPercentage: !achievement.nextTierTarget
      ? 100
      : Math.round((achievement.progress / achievement.nextTierTarget) * 100),
    nextTierTarget: Math.round(
      achievement.id === "time_played"
        ? achievement.nextTierTarget / 60
        : achievement.nextTierTarget,
    ),
    currentTierTarget:
      achievementAssets?.values?.[achievement.currentTier - 1]?.value,
    currentTierGems: achievementAssets?.values?.[achievement.currentTier - 1]?.gems,
    achievementImage: achievementAssets?.icons[achievement.currentTier],
    color: ACHIEVEMENTS_BG_COLORS[achievement.currentTier],
    achievementName: achievementAssets?.name,
    description: achievementAssets?.description,
    nextTierIcon: achievementAssets?.icons?.[achievement.currentTier + 1],
  };
};

export const sortAchievementsByOrder = (achievements?: Achievement[]) => {
  if (!achievements) return [];
  const achievementSorted = ACHIEVEMENTS_ORDER.map((achievementId) => {
    return achievements.find((a) => a.id === achievementId);
  });

  return compact(achievementSorted);
};

export const getDifferentAchievements = (
  oldAchievements: Achievement[],
  newAchievements: Achievement[],
) => {
  const isNewlyUnlockedTier = (newAchievement: Achievement) => {
    const oldAchievement = oldAchievements.find(
      (a) => a.id === newAchievement.id,
    );
    if (!oldAchievement) {
      return false;
    }
    return newAchievement.currentTier > oldAchievement.currentTier;
  };
  if (isEmpty(newAchievements) || isEmpty(oldAchievements)) return [];
  return differenceWith(newAchievements, oldAchievements, isEqual).filter(
    isNewlyUnlockedTier,
  );
};

export const getAchievementsWithProgress = (
  oldAchievements: Achievement[],
  newAchievements: Achievement[],
) => {
  const isUnlockedOrProgressChanged = (achievement: Achievement) => {
    return (achievement.currentTier > 0 || achievement.progress > 0) && achievement.nextTierTarget!=null;
  };
  if (isEmpty(newAchievements)) return [];
  if (isEmpty(oldAchievements)) {
    return newAchievements.filter(isUnlockedOrProgressChanged);
  }
  return differenceWith(newAchievements, oldAchievements, isEqual).filter(
    isUnlockedOrProgressChanged,
  );
};
